// extracted by mini-css-extract-plugin
export default {"MarkdownResponse":"MarkdownResponse_MarkdownResponse__zT5y2","MarkdownResponseCondensed":"MarkdownResponse_MarkdownResponseCondensed__GYlrR"};